export const trialAlwaysIncluded: string[] = [
  'Free learning resources, support & community access',
  'Limited time introductory prices',
];
